// Chrome palette of the new phone editor — the SAME CSS variables the classic
// editor chrome uses (AlbumEditorPage `UI`), so night mode keeps working for
// staff and light mode is pixel-identical in colour.
export const M2 = {
  ink: 'var(--color-ed-ink)',
  muted: 'var(--color-adm-muted)',
  surface: 'var(--color-adm-surface)',
  panel: 'var(--color-ed-panel)',
  desk: 'var(--color-ed-desk)',
  goldInk: 'var(--color-adm-gold-ink)',
  line: 'var(--color-adm-line)',
  danger: 'var(--color-ed-danger)',
  gold: '#C9A24A',
  goldDark: '#8B6F26',
  success: '#047857',
} as const;
